import React from 'react'
import { Link } from 'react-router'

export default {
  login: 'Entrar',
  email: 'Email',
  twoFactor: 'Two factor code',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña',
  register: 'Registrarse',
  passwordDoesntMatch: 'Las contraseñas no coinciden',
  passwordDoesntRequire: 'Debe de tener mínimo 8 caracteres, una minúscula, una mayúscula y un número',
  otherLinksInRegister: () => (
    <div>Si ya tienes cuenta <Link to='/login'>entra</Link></div>
  ),
  otherLinksInLogin: () => (
    <div>
      Si no tienes cuenta
      {' '}
      <Link to='/register'>registrate</Link>
      {' '}
      <Link to='/forgot'>Olvidé mi contraseña</Link>
    </div>
  ),
  otherLinkForgetPassword: () => (
    <div>
      <Link to='/forgot'> Olvidé mi contraseña</Link>
    </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/pages/es.js